import { ClientForm } from '@components/client'
import { ArrowLeft, Plus, ShieldCheck, UserPlus } from 'lucide-react'
import PropTypes from 'prop-types'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import classes from './VehicleInfo.module.css'

import {
  requestCreateWO,
  requestSafetySystems,
  updateQuote,
  updateWorkOrder,
  getWorkOrderByReferenceNumber,
  getInvoiceByReferenceNumber,
  getQuoteByReferenceNumber,
  getAttachmentAppointmentEstimate,
  useSubmitFileAttachment
} from '../../api/api'

import { VehicleInfoDetails } from '@components/vehicle-info-details'
import _ from 'lodash'
import { useParams } from 'react-router-dom'

import { useCenterStore } from '@caradasstore/CenterStore'
import { CarImageHolder } from '@components/car-image-holder'
import { VinInput } from '@components/vin'
import {
  AdasBox,
  AdasButton,
  AdasCheckbox,
  AdasContainer,
  AdasFormControlLabel,
  AdasFormGroup,
  AdasRadioGroup,
  AdasSelect,
  AdasTextField,
  AdasTypography,
  AdasAutoComplete
} from '@components/wrapper-components'
import { useHistory, useLocation } from 'react-router-dom'
import { getQuoteSummaryUrl, getWorkOrderSummaryUrl, PARAM_NAMES, REDIRECT_URLS, BUTTONS_DISPLAY_LABEL } from '../../constants'
import { useScrollTop } from '../../utils/useScrollTop'
import { CaradasSnackbar } from '@components/snackbar'
import { GENERIC_MESSAGES } from '../../constants'
import { StatusEnum } from '../../enums/enums'
import { Logger } from '../../logger'
import { useLoadingStore } from '@caradasstore/LoadingStore'
import { useMessageStore } from '@caradasstore/MessageStore'
import { getFriendlyErrorMessage } from '../../utils/errorMessage'
import { ATTACHMENT_TYPE_MAP, MIME_TYPES_MAP } from 'variable-maps'
import { VehicleInfoManuallPage } from './VehicleInfoManuallPage'
import { useClientAndInsuranceData } from '../../hooks/useClientAndInsuranceData'
import { useInitReferralAndInsuranceFromState } from '@hooks/useInitReferralAndInsuranceFromState'
import { useReferralAutoMatch } from '@hooks/useReferralAutoMatch'
import { useIsReadOnly } from '@hooks/useIsReadOnly'
import { ConfirmModal } from '@components/common'
import { FormModal } from '@components/branded-modal'
import { AlertTriangle } from 'lucide-react'
export const VehicleInfoPage = (props) => {
  useScrollTop()
  const location = useLocation()
  const referralSourceCode = location.state?.referral
  const { [PARAM_NAMES.REFERENCE_NUMBER]: referenceNumber } = useParams()
  const { fromWorkOrder = false, fromInvoice = false, fromQuote = false, isNewWorkOrder } = props
  const isReadOnlyUser = useIsReadOnly()
  const [isAddClient, setIsAddClient] = useState(false)
  const [vehicleData, setVehicleData] = useState({})
  const [displayDetails, setDisplayDetails] = useState(false)
  const [isDrawOpen, setIsDrawOpen] = useState(false)
  const [customerPay, setCustomerPay] = useState(false)
  const [safetySystemItems, setSafetySystemItems] = useState([])
  const [openSnackBar, setOpenSnackBar] = useState(false)
  const [showInsuranceChangeModal, setShowInsuranceChangeModal] = useState(false)
  const [pendingInsuranceCompanyId, setPendingInsuranceCompanyId] = useState(null)
  const [manualOverRideVin, setManualOverRideVin] = useState(false)
  const [preCalRepairEstimateScan, setPreCalRepairEstimateScan] = useState(null)
  const [formInputValues, setFormInputValues] = useState({
    client: '',
    roNumber: '',
    vin: '',
    serviceType: 'STANDARD',
    insurance_company_id: '',
    appointment_id: '',
    referral_source_code: referralSourceCode || null,
    vehicleYear: '',
    vehicleMake: '',
    vehicleModel: '',
    vehicleTrim: ''
  })
  const [workOrderData, setWorkOrderData] = useState({}) //Object holds Quote/WorkOrder/Invoice data
  const prePopulateVin = isNewWorkOrder && (location.state?.prepopulateVin || location.state?.vin)
  const history = useHistory()
  const { uploadData } = useSubmitFileAttachment()

  const [isVinServiceDown, setIsVinServiceDown] = useState(false)
  const redirectToForbiddenPage = () => {
    history.replace(REDIRECT_URLS.FORBIDDEN_PAGE)
  }

  const previousSafetySystemRef = useRef([])
  const ccId = useCenterStore((store) => store.ccId)
  const setLoading = useLoadingStore((store) => store.setLoading)
  const addMessage = useMessageStore((store) => store.addMessage)
  const {
    clients,
    insuranceCompanies,
    fetchClients,
    clearVehicleFields,
    fetchReferralSource,
    referralSourceList,
    handleVehicleManualChange
  } = useClientAndInsuranceData(ccId)

  useEffect(() => {
    if (location.state?.appointment_id) {
      setFormInputValues((prevState) => ({
        ...prevState,
        roNumber: location.state?.aro || '',
        appointment_id: location.state?.appointment_id || ''
      }))
    }
  }, [location.state?.appointment_id, setFormInputValues])
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (fromQuote || fromInvoice || fromWorkOrder) {
          setLoading(true)
        }
        if (fromQuote) {
          const quoteResponse = await getQuoteByReferenceNumber({
            referenceNumber: referenceNumber
          })
          if (quoteResponse?.status === 200) {
            quoteResponse.data.quote.safetySystemsItems = quoteResponse.data.safetySystemsItems || []
            setWorkOrderData(quoteResponse.data?.quote)
          } else {
            //Given referenceNumber doesnot exist or no permission granted
            redirectToForbiddenPage()
            return
          }
        }
        if (fromInvoice) {
          let response = await getInvoiceByReferenceNumber({ referenceNumber })
          if (response?.status === 200) {
            if (!response.data?.invoiceDto) {
              redirectToForbiddenPage()
              return
            }
            response.data.invoiceDto.safetySystemsItems = response.data.safetySystemsItems || []
            setWorkOrderData(response.data.invoiceDto)
          } else {
            //Given referenceNumber doesnot exist or no permission granted
            redirectToForbiddenPage()
            return
          }
        }
        if (fromWorkOrder) {
          let response = await getWorkOrderByReferenceNumber({ referenceNumber })
          if (response?.status === 200) {
            //Url Tampared i.e invoice/quote record tried to open in workorder path
            if (StatusEnum[response.data?.workOrder?.status] === StatusEnum.MOVED) {
              redirectToForbiddenPage()
              return
            }
            response.data.workOrder.safetySystemsItems = response.data.safetySystemsItems || []
            setWorkOrderData(response.data.workOrder)
          } else {
            //Given referenceNumber doesnot exist or no permission granted
            redirectToForbiddenPage()
            return
          }
        }
      } catch (error) {
        Logger.error({
          message: error,
          payload: {
            referenceNumber
          }
        })
      } finally {
        setLoading(false)
      }
    }
    if (!(isNewWorkOrder && location.state?.prepopulateVin) && referenceNumber) fetchData()
  }, [referenceNumber])

  useEffect(() => {
    // if not a new workorder, we need to get data from location to render vehicle info
    if (!isNewWorkOrder) {
      const clientId = workOrderData.client?.id

      const updateValues = {
        client: clientId,
        roNumber: workOrderData.repair_order_num,
        insurance_company_id: workOrderData?.insurance_company?.id,
        vin: workOrderData?.vehicle?.vin || ''
      }
      setFormInputValues(updateValues)
      setCustomerPay(workOrderData.repair_order_num === 'Customer-Pay')

      const existingVehicleData = {
        ...workOrderData.vehicle,
        color: workOrderData.vehicle?.exterior_color,
        imageUrl: workOrderData.vehicle?.image_url,
        safetySystemsItems: workOrderData.safetySystemsItems || []
      }
      setDisplayDetails(true)
      setVehicleData(existingVehicleData)
    }
  }, [
    workOrderData?.client?.id,
    workOrderData?.repair_order_num,
    workOrderData?.safetySystemsItems,
    workOrderData?.vehicle,
    workOrderData?.insurance_company_dto?.id,
    isNewWorkOrder
  ])

  const title = props.title

  const isEnabled = useMemo(() => {
    const clientValid = !!formInputValues.client

    const vinValid =
      (!!formInputValues.vin && !manualOverRideVin && !isVinServiceDown) ||
      (manualOverRideVin &&
        formInputValues.vehicleYear &&
        formInputValues.vehicleMake &&
        formInputValues.vehicleModel &&
        formInputValues.vehicleTrim) ||
      referenceNumber

    const roNumberValid = customerPay || !!formInputValues.roNumber
    const isInsuranceCompanyValid = !!formInputValues.insurance_company_id

    return vinValid && clientValid && roNumberValid && isInsuranceCompanyValid
  }, [
    customerPay,
    formInputValues.client,
    formInputValues.vin,
    formInputValues.roNumber,
    formInputValues.vehicleYear,
    formInputValues.vehicleMake,
    formInputValues.vehicleModel,
    formInputValues.vehicleTrim,
    isVinServiceDown,
    formInputValues.insurance_company_id
  ])

  const redirectWorkOrderSummary = useCallback(
    async (data) => {
      if (fromQuote) {
        history.push(getQuoteSummaryUrl(data?.quote?.reference_number ?? data?.reference_number))
      } else {
        history.push(getWorkOrderSummaryUrl(data?.workOrder?.reference_number ?? data?.reference_number))
      }
    },
    [fromInvoice, fromQuote, history]
  )

  const changeHandler = useCallback(
    (e) => {
      setFormInputValues((prevValues) => {
        return { ...prevValues, [e.target.name]: e.target.value }
      })
    },
    [setFormInputValues]
  )

  const { autoMatchedReferral, setAutoMatchedReferral, showReferralField, setShowReferralField, matchReferral } = useReferralAutoMatch({
    insuranceCompanies,
    referralSourceList,
    setFormInputValues,
    referralSourceCode
  })

  useInitReferralAndInsuranceFromState({
    referralSourceCode,
    insuranceCompanies,
    setFormInputValues,
    setAutoMatchedReferral: setAutoMatchedReferral, // optional, only in VehicleInfoPage
    setShowReferralField,
    ccId: ccId
  })
  const handleShowReferralField = useCallback(
    (e) => {
      const isYesSelected = e.target.value === 'true'
      setShowReferralField(isYesSelected)

      setFormInputValues((prev) => {
        const updated = { ...prev }

        if (isYesSelected) {
          matchReferral(prev.insurance_company_id)
        } else {
          updated.referral_source_code = null
        }

        return updated
      })
    },
    [matchReferral]
  )

  const handleCustomerPay = useCallback((e) => {
    const value = /true/.test(e.target.value)
    const roNumber = value ? 'Customer-Pay' : ''
    setCustomerPay(value)
    setFormInputValues((prevValues) => {
      return { ...prevValues, roNumber: roNumber }
    })
  }, [])

  const openSafetySystem = useCallback(() => {
    requestSafetySystems({})
      .then((response) => {
        if (response?.status === 200) {
          let allSafetySystems = []
          response.data?.forEach((system) =>
            allSafetySystems.push({
              safety_system_master_id: system.id,
              checked: false,
              ...system
            })
          )
          if (vehicleData && vehicleData.safetySystemsItems && vehicleData.safetySystemsItems.length > 0) {
            vehicleData.safetySystemsItems.forEach((safety) => {
              const matchingSystem = allSafetySystems.find((item) => item.unique_key === safety.unique_key)
              if (matchingSystem) {
                matchingSystem.checked = true
              }
            })
          }
          setIsDrawOpen(true)
          allSafetySystems.sort((a, b) => a.feature_name?.toLowerCase().localeCompare(b.feature_name?.toLowerCase()))
          setSafetySystemItems(allSafetySystems)
        }
      })
      .catch((err) => {
        console.log('ERROR ', err)
      })
  }, [vehicleData])

  const uploadFile = useCallback(
    async (file, type, id) => {
      const formData = new FormData()
      formData.append('file', file, file.name)
      let attachmentType = ATTACHMENT_TYPE_MAP[type]
      const params = {
        data: formData,
        workorderId: id,
        type: 'workorders',
        attachmentType
      }

      const response = uploadData(params)
      response.then(() => {})
    },
    [uploadData]
  )

  useEffect(() => {
    const fetchFileData = async (value) => {
      try {
        const response = await getAttachmentAppointmentEstimate(ccId, value.appointment_id)
        const fileFromResponse = new File([response.data], value.name, {
          type: MIME_TYPES_MAP[`.${value.file_extension}`] // Ensure the correct MIME type is used
        })

        setPreCalRepairEstimateScan(fileFromResponse)
      } catch (error) {
        Logger.error({ message: error.message, payload: { value } })
      }
    }

    if (location.state?.recentEstimate?.id) {
      fetchFileData(location.state?.recentEstimate)
    }
  }, [location.state?.recentEstimate?.id])

  const submitHandler = useCallback(async () => {
    setLoading(true)
    const { color, imageUrl, fuel, ...vehicle } = vehicleData
    const workOrderRequestData = {
      referral_source_code: formInputValues.referral_source_code,
      client_id: formInputValues.client,
      calibration_center_id: ccId,
      repair_order_num: formInputValues.roNumber,
      quote: fromQuote,
      type: formInputValues.serviceType,
      insurance_company_id: formInputValues.insurance_company_id,
      vehicle: {
        vin: formInputValues.vin,
        calibration_center_id: ccId,
        exterior_color: color,
        image_url: imageUrl,
        fuel_capacity_gal: fuel,
        safetySystemsItems:
          vehicleData.safetySystemsItems?.map((item) => {
            return item
          }) || [],
        year: isVinServiceDown && formInputValues.vehicleYear ? formInputValues.vehicleYear : vehicle.year,
        make: isVinServiceDown && formInputValues.vehicleMake ? formInputValues.vehicleMake : vehicle.make,
        model: isVinServiceDown && formInputValues.vehicleModel ? formInputValues.vehicleModel : vehicle.model,
        trim: isVinServiceDown && formInputValues.vehicleTrim ? formInputValues.vehicleTrim : vehicle.trim,
        ...vehicle
      },
      appointment_id: formInputValues.appointment_id
    }
    try {
      const response = await requestCreateWO({ data: workOrderRequestData })
      if (response.status === 201) {
        const id = response.data.workOrder.id
        if (preCalRepairEstimateScan) {
          uploadFile(preCalRepairEstimateScan, 'preCalRepairEstimateScan', id)
        }

        setLoading(false)
        redirectWorkOrderSummary(response.data)
      }
    } catch (err) {
      Logger.error({ message: err, payload: { file: 'VehicleInfoPage/submitHandler' }, workOrderRequestData })
      addMessage({ text: getFriendlyErrorMessage(err) })
    } finally {
      setLoading(false)
    }
  }, [
    addMessage,
    ccId,
    formInputValues.client,
    formInputValues.roNumber,
    formInputValues.serviceType,
    formInputValues.vin,
    fromQuote,
    redirectWorkOrderSummary,
    vehicleData,
    formInputValues.vehicleYear,
    formInputValues.vehicleMake,
    formInputValues.vehicleModel,
    formInputValues.vehicleTrim,
    formInputValues.insurance_company_id
  ])

  const handleSafetySystemChange = useCallback(
    (e) => {
      const uniqueKey = e.target.value
      setSafetySystemItems((prevItems) => {
        const updatedItems = prevItems.map((item) => (item.unique_key === uniqueKey ? { ...item, checked: e.target.checked } : item))
        updatedItems.sort((a, b) => a.feature_name?.toLowerCase().localeCompare(b.feature_name?.toLowerCase()))
        return updatedItems
      })
    },
    [safetySystemItems]
  )

  const handleCloseSafetySystemEdit = useCallback(() => {
    const newSafetySystem = safetySystemItems
      .filter((item) => item.checked)
      .map((item) => ({
        ...item,
        id: null
      }))

    previousSafetySystemRef.current = vehicleData.safetySystemsItems
      .map((item) => {
        if (item.feature_name) {
          return {
            ...item
          }
        }
        return null
      })
      .filter(Boolean)

    setVehicleData((prevValues) => {
      const updateValues = {
        ...prevValues,
        safetySystemsItems: newSafetySystem
      }
      return updateValues
    })

    setIsDrawOpen(false)

    const sortedPreviousSafetySystemRef = _.sortBy(previousSafetySystemRef.current, 'feature_name')

    if (!_.isEqual(newSafetySystem, sortedPreviousSafetySystemRef)) {
      //setOpenSnackBar(true) // Open the snackbar if there are differences //hiding undo
    }
  }, [safetySystemItems, vehicleData.safetySystemsItems])

  const undoSafetySystemHandler = useCallback(() => {
    setVehicleData((prevState) => {
      const data = {
        ...prevState,
        safetySystemsItems: previousSafetySystemRef.current
      }
      return data
    })
    setOpenSnackBar(false)
  }, [])

  const updateVehicleInfo = async () => {
    // eslint-disable-next-line no-unused-vars
    const { safetySystemsItems, color, imageUrl, fuel, ...vehicle } = vehicleData
    if (fromQuote) {
      const submitData = {
        id: workOrderData.id,
        client_id: formInputValues.client,
        calibration_center_id: ccId,
        repair_order_num: formInputValues.roNumber,
        insurance_company_id: formInputValues.insurance_company_id,
        referral_source_code: formInputValues.referral_source_code,
        quote: fromQuote,
        vehicle: {
          vin: formInputValues.vin,
          calibration_center_id: ccId,
          exterior_color: color,
          image_url: imageUrl,
          fuel_capacity_gal: fuel,
          safetySystemsItems: safetySystemsItems,
          ...vehicle
        }
      }

      try {
        const response = await updateQuote({
          data: submitData,
          quoteId: submitData.id
        })

        if (response.status === 200) {
          redirectWorkOrderSummary(response.data)
        }
      } catch (err) {
        Logger.error({ message: err, payload: { file: 'VehicleInfoPage/updateVehicleInfo/fromQuote', submitData } })
      }
    } else {
      const data = {
        workorder_id: workOrderData.id,
        client_id: formInputValues.client,
        repair_order_num: formInputValues.roNumber,
        insurance_company_id: formInputValues.insurance_company_id,
        referral_source_code: formInputValues.referral_source_code,
        safetySystems: safetySystemsItems
      }

      try {
        const response = await updateWorkOrder({
          data: data
        })

        if (response.status === 200) {
          history.goBack()
        }
      } catch (err) {
        Logger.error({ message: err, payload: { file: 'VehicleInfoPage/updateVehicleInfo', data } })
      }
    }
  }

  const updateVehicleDetails = useCallback(
    (props) => {
      setDisplayDetails(true)
      setVehicleData({ ...props.data, safetySystemsItems: props.data?.safetySystems })
      setFormInputValues((prevValues) => {
        const updatedValues = {
          ...prevValues,
          vin: props.vin
        }
        return updatedValues
      })
    },
    [setDisplayDetails, setVehicleData, setFormInputValues]
  )

  const isReferralInsurance = useCallback(
    (insuranceCompanyId) => {
      const selectedInsurance = insuranceCompanies.find((company) => company.id === insuranceCompanyId)
      return referralSourceList.some((referral) => referral.value?.toLowerCase() === selectedInsurance?.name?.toLowerCase())
    },
    [insuranceCompanies, referralSourceList]
  )

  const autocompleteHandler = useCallback(
    (event) => {
      const { name, value } = event.target
      if (name === 'insurance_company_id') {
        if (value === formInputValues.insurance_company_id) {
          return
        }
        if (!isNewWorkOrder && (isReferralInsurance(value) || isReferralInsurance(formInputValues.insurance_company_id))) {
          setPendingInsuranceCompanyId(value)
          setShowInsuranceChangeModal(true)
          return
        }
      }

      setFormInputValues((prevValues) => ({
        ...prevValues,
        [name]: value || ''
      }))

      // Match referral only when changing insurance
      if (name === 'insurance_company_id') {
        matchReferral(value)
      }
    },
    [formInputValues.insurance_company_id, isNewWorkOrder, isReferralInsurance, matchReferral, setFormInputValues]
  )

  const handleInsuranceChangeConfirm = useCallback(() => {
    if (!pendingInsuranceCompanyId) {
      setShowInsuranceChangeModal(false)
      return
    }

    setFormInputValues((prevValues) => ({
      ...prevValues,
      insurance_company_id: pendingInsuranceCompanyId
    }))
    matchReferral(pendingInsuranceCompanyId)
    setPendingInsuranceCompanyId(null)
    setShowInsuranceChangeModal(false)
  }, [matchReferral, pendingInsuranceCompanyId])

  const handleInsuranceChangeCancel = useCallback(() => {
    setPendingInsuranceCompanyId(null)
    setShowInsuranceChangeModal(false)
  }, [])

  const handleVehicleManuallChange = (eventOrValue) => {
    handleVehicleManualChange(eventOrValue, setFormInputValues)
  }

  useEffect(() => {
    if (isNewWorkOrder && isVinServiceDown) {
      clearVehicleFields(setFormInputValues)
      setManualOverRideVin(false)
    }
  }, [isNewWorkOrder, isVinServiceDown])

  useEffect(() => {
    clearVehicleFields(setFormInputValues)
  }, [manualOverRideVin])

  useEffect(() => {
    fetchReferralSource()
  }, [fetchReferralSource])

  const disableEdit = workOrderData
    ? StatusEnum[workOrderData.status] === StatusEnum.CLOSED || fromInvoice || isReadOnlyUser
    : isReadOnlyUser

  // Compose the page title + the back-to-summary label based on the entry context.
  const sourceLabel = fromInvoice ? 'Invoice' : fromWorkOrder ? 'Work Order' : 'Quote'
  const backLabel = isNewWorkOrder ? 'Back' : `Back to ${sourceLabel} Summary`
  const submitLabel = isNewWorkOrder ? 'CREATE WORK ORDER' : 'UPDATE'
  const submitFn = isNewWorkOrder ? submitHandler : updateVehicleInfo
  const submitDisabled = isNewWorkOrder ? !isEnabled : disableEdit || !isEnabled
  const wo = workOrderData || {}
  const veh = wo.vehicle || vehicleData || {}
  const vehicleSummary = [veh.year, veh.make, veh.model, veh.trim].filter(Boolean).join(' ')

  return (
    <AdasContainer maxWidth={false}>
      <AdasBox className='mb-[60px] mt-5'>
        {/* Add-client modal */}
        {isAddClient && (
          <FormModal open={isAddClient} onClose={() => setIsAddClient(false)} title='Client Info' icon={UserPlus} width='max-w-[520px]'>
            <ClientForm onSaveSuccess={fetchClients} clibrationCenterId={Number(ccId)} close={() => setIsAddClient(false)} />
          </FormModal>
        )}

        {/* Safety systems edit modal */}
        <FormModal
          open={isDrawOpen}
          onClose={handleCloseSafetySystemEdit}
          title='Installed Safety Systems'
          icon={ShieldCheck}
          width='max-w-[520px]'
        >
          <AdasFormGroup className={classes.drawer}>
            {safetySystemItems.map((system, index) => (
              <AdasFormControlLabel
                className={classes.description}
                key={index}
                control={
                  <AdasCheckbox
                    label={system.feature_name}
                    checked={system.checked}
                    onChange={handleSafetySystemChange}
                    value={system.unique_key}
                  />
                }
                label={system.feature_name}
              />
            ))}
          </AdasFormGroup>
        </FormModal>

        {/* Page header — back link + title (desktop only); mobile uses the global nav header + native back */}
        <AdasBox className='mb-6'>
          <AdasBox className='hidden min-[435px]:block'>
            <button
              type='button'
              onClick={() => history.goBack()}
              className='mb-1 inline-flex items-center gap-1.5 text-[13px] font-medium text-[#1F6FEB] hover:underline'
            >
              <ArrowLeft className='h-4 w-4' />
              {backLabel}
            </button>
            <AdasTypography className='text-[28px] font-bold leading-tight text-[#0A1628]'>{title || 'Vehicle Info'}</AdasTypography>
          </AdasBox>
          {wo.id && !isNewWorkOrder && (
            <AdasTypography className='mt-1 text-[13px] text-[#475569]'>
              <span>{sourceLabel}# </span>
              <span className='font-mono'>{wo.reference_number}</span>
              {wo.repair_order_num && (
                <>
                  <span className='mx-2 text-[#CBD5E1]'>·</span>
                  <span>RO# </span>
                  <span className='font-mono'>{wo.repair_order_num}</span>
                </>
              )}
              {vehicleSummary && (
                <>
                  <span className='mx-2 text-[#CBD5E1]'>·</span>
                  <span>{vehicleSummary}</span>
                </>
              )}
            </AdasTypography>
          )}
        </AdasBox>

        {/* Step 1 — Client & repair order */}
        <AdasBox className='mb-4 rounded-xl border border-[#EBEDF0] bg-white px-6 py-5 shadow-sm'>
          <AdasBox className='mb-5 flex items-center gap-3 border-b border-[#EBEDF0] pb-4'>
            <span className='inline-flex h-7 w-7 flex-none items-center justify-center rounded-full bg-[#0A1628] text-[12px] font-bold text-white'>
              1
            </span>
            <AdasTypography className='text-[15px] font-bold text-[#0A1628]'>Client &amp; repair order</AdasTypography>
          </AdasBox>

          {/* Client (Select + add button) — same shape as NewQuote */}
          <AdasBox className='mb-5'>
            <AdasTypography className='mb-1.5 text-[11px] font-semibold uppercase tracking-wide text-[#6B7280]'>
              Client<span className='ml-0.5 text-[#E24B4A]'>*</span>
            </AdasTypography>
            <AdasBox className='flex items-stretch w-full'>
              <AdasSelect
                labelId='clients'
                id='client-select'
                name='client'
                value={formInputValues.client}
                onChange={autocompleteHandler}
                disabled={disableEdit}
                options={clients || []}
                className='flex-1 min-w-0 text-left rounded-r-none border-r-0'
              />
              <button
                type='button'
                onClick={() => setIsAddClient(true)}
                disabled={disableEdit}
                aria-label='Add client'
                className='inline-flex items-center justify-center h-11 w-12 rounded-r-lg rounded-l-none bg-sidebar text-white hover:bg-sidebar/90 border border-l-0 border-sidebar transition-colors shrink-0 disabled:cursor-not-allowed disabled:opacity-40'
              >
                <Plus className='h-5 w-5' />
              </button>
            </AdasBox>
          </AdasBox>

          <AdasBox className='mb-5'>
            <AdasTypography className='mb-1.5 text-[11px] font-semibold uppercase tracking-wide text-[#6B7280]'>
              Repair order
            </AdasTypography>
            <AdasRadioGroup
              row
              options={[
                { label: 'RO Provided', value: false },
                { label: 'Customer Pay', value: true }
              ]}
              disabled={disableEdit}
              name='clientPay'
              value={customerPay}
              onChange={handleCustomerPay}
            />
          </AdasBox>

          <AdasBox className='mb-5'>
            <AdasTypography className='mb-1.5 text-[11px] font-semibold uppercase tracking-wide text-[#6B7280]'>
              RO #<span className='ml-0.5 text-[#E24B4A]'>*</span>
            </AdasTypography>
            <AdasTextField
              id='ro-number'
              variant='outlined'
              placeholder='RO #'
              disabled={customerPay || disableEdit}
              name='roNumber'
              onChange={changeHandler}
              value={formInputValues.roNumber}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </AdasBox>

          <AdasBox className={isNewWorkOrder ? 'mb-5' : ''}>
            <AdasTypography className='mb-1.5 text-[11px] font-semibold uppercase tracking-wide text-[#6B7280]'>
              Insurance Company<span className='ml-0.5 text-[#E24B4A]'>*</span>
            </AdasTypography>
            <AdasAutoComplete
              labelId='insurance_label'
              id='insurance_company_id'
              name='insurance_company_id'
              placeholder='Insurance Company (Required)'
              value={formInputValues.insurance_company_id}
              onChange={autocompleteHandler}
              disabled={disableEdit}
              options={insuranceCompanies || []}
              className='w-full text-left'
            />
          </AdasBox>

          {isNewWorkOrder && (
            <AdasBox>
              <AdasTypography className='mb-1.5 text-[11px] font-semibold uppercase tracking-wide text-[#6B7280]'>Type</AdasTypography>
              <AdasRadioGroup
                row
                options={[
                  { label: 'Standard', value: 'standard' },
                  { label: 'Service Only', value: 'serviceOnly' }
                ]}
                name='serviceType'
                value={formInputValues.serviceType}
                onChange={changeHandler}
              />
            </AdasBox>
          )}
        </AdasBox>

        {/* Step 2 — Vehicle */}
        <AdasBox className='mb-4 rounded-xl border border-[#EBEDF0] bg-white px-6 py-5 shadow-sm'>
          <AdasBox className='mb-5 flex items-center gap-3 border-b border-[#EBEDF0] pb-4'>
            <span className='inline-flex h-7 w-7 flex-none items-center justify-center rounded-full bg-[#0A1628] text-[12px] font-bold text-white'>
              2
            </span>
            <AdasTypography className='text-[15px] font-bold text-[#0A1628]'>Vehicle</AdasTypography>
          </AdasBox>

          {isNewWorkOrder && (
            <AdasBox className='mb-4'>
              <AdasTypography className='mb-1.5 text-[11px] font-semibold uppercase tracking-wide text-[#6B7280]'>
                VIN<span className='ml-0.5 text-[#E24B4A]'>*</span>
              </AdasTypography>
              <VinInput
                updateVehicleInfo={updateVehicleDetails}
                prepopulateVin={prePopulateVin}
                vinExistCheck={true}
                setIsVinServiceDown={setIsVinServiceDown}
              />
            </AdasBox>
          )}

          {!isVinServiceDown &&
            (displayDetails ? (
              <VehicleInfoDetails data={vehicleData} qwi={referenceNumber} openDraw={openSafetySystem} disabled={disableEdit} />
            ) : (
              <CarImageHolder />
            ))}

          {isNewWorkOrder && isVinServiceDown && (
            <>
              <AdasTypography className='mb-3 text-[13px] italic text-[#475569]'>
                If VIN results in an error message, select Manually Enter Vehicle Details below
              </AdasTypography>
              <VehicleInfoManuallPage
                formInputValues={formInputValues}
                setFormInputValues={setFormInputValues}
                handleVehicleManuallChange={handleVehicleManuallChange}
                manualOverRideVin={manualOverRideVin}
                setManualOverRideVin={setManualOverRideVin}
              />
            </>
          )}
        </AdasBox>

        {/* Bottom action bar */}
        <AdasBox className='mt-6 flex flex-wrap items-center justify-end gap-3'>
          <AdasButton variant='outlined' aria-label='Cancel' onClick={() => history.goBack()} className='rounded-lg px-6 font-semibold'>
            CANCEL
          </AdasButton>
          {!isReadOnlyUser && (
            <AdasButton
              disabled={submitDisabled}
              variant='contained'
              aria-label={submitLabel}
              isDebounceEnabled
              onClick={submitFn}
              className='rounded-lg bg-[#0A1628] px-6 font-semibold text-white hover:bg-[#1F2D3D]'
            >
              {submitLabel}
            </AdasButton>
          )}
        </AdasBox>

        <AdasBox>
          <CaradasSnackbar
            open={openSnackBar}
            message={GENERIC_MESSAGES.SAFETY_SYSTEMS_UPDATED}
            onClose={setOpenSnackBar}
            onUndo={undoSafetySystemHandler}
          />
        </AdasBox>
        <ConfirmModal
          open={showInsuranceChangeModal}
          title='Change Insurance Company?'
          message={
            <AdasBox className='flex items-start my-[20px] mx-0 gap-4'>
              <AlertTriangle className='w-12 h-12 mt-0.5 text-warning' />
              <AdasTypography variant='subtitle1' className='wordWrap'>
                Changing to or from a National Agreement provider will permanently remove all selected products, resetting your cart to
                $0.00.
              </AdasTypography>
            </AdasBox>
          }
          confirmLabel={BUTTONS_DISPLAY_LABEL.CONFIRM}
          handleContinue={handleInsuranceChangeConfirm}
          handleClose={handleInsuranceChangeCancel}
        />
      </AdasBox>
    </AdasContainer>
  )
}

VehicleInfoPage.propTypes = {
  title: PropTypes.string,
  fromInvoice: PropTypes.bool,
  fromQuote: PropTypes.bool,
  isNewWorkOrder: PropTypes.bool
}
